// extracted by mini-css-extract-plugin
export var aboutLink = "navigation-module--aboutLink--5OjQ6";
export var aboutTitle = "navigation-module--aboutTitle--GWYJf";
export var activeStyle = "navigation-module--activeStyle--5KgGI";
export var cart = "navigation-module--cart--el6K9";
export var header = "navigation-module--header--ZQ5Ay";
export var logoContainer = "navigation-module--logoContainer--sk1Fo";
export var logoLink = "navigation-module--logoLink--qxXZS";
export var monogram = "navigation-module--monogram--CJToM";
export var styledText = "navigation-module--styledText--FvxDm";